import React from 'react';
import { Link } from 'react-router-dom';
import HertzLogo from '@assets/images/static/hz-ebook.png';
import { useTranslation } from 'react-i18next';

const HertzLogoType: React.FC = () => {
  const {t} = useTranslation();
  return (
    <Link
      to={'/home'}
      style={{
        padding: '0.75rem',
        height: '100%'
      }}
    >
    <img
      loading={"eager"}
      {...{ fetchpriority: "high" }} // react does not recognize this property due to a bug slated to be fixed in react 19
      src={HertzLogo}
      alt={t('company_logotype')}
      style={{ maxHeight: '100%' }} />
    </Link>
  );
};

export default HertzLogoType;

